export const types = {
  SET_BETSLIP_WIDGET_CONFIG: 'SET_BETSLIP_WIDGET_CONFIG',
  SET_CONTENT_HEIGHT: 'SET_CONTENT_HEIGHT'
};
